module.exports = __webpack_public_path__ + "appengine.icon.d44e5.svg";


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/appengine/logo/appengine.icon.svg
// module id = 3606
// module chunks = 0